import { render, staticRenderFns } from "./state.vue?vue&type=template&id=08b8586c&"
import script from "./state.vue?vue&type=script&lang=js&"
export * from "./state.vue?vue&type=script&lang=js&"
import style0 from "./state.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports